/* Copyright (C) Envialo México SA de CV - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by:
 * @author América Mendoza  <amendoza@nodeport.co>,
 * @author Darién Miranda <dmiranda@nodeport.co>,
 * @author Oscar Peña <opena@nodeport.co>,
 * March 2026
 */

import React from 'react';
import {withRouter} from "react-router";
import Row from "react-bootstrap/cjs/Row";
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form"
import NbioApi from "../../lib/api/NbioApi";
import {toast} from "sonner";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";


//components
import BootstrapTable from "react-bootstrap-table-next";
import CategoryImageUploader from "./CategoryImageUploader";



class Category extends React.Component {
    constructor(p) {
        super(p);
        this.state = {
            category: {
                images:[],
                name:'',
            },
            childrenCategories:[],
            isLoading:false,
        }
        this.loadCategory            = this.loadCategory.bind(this);
        this.onChange                = this.onChange.bind(this);
    }
    
    componentDidMount() {
        const categoryId = this.props.match.params.id;
        
        this.loadCategory(categoryId);
    }

    onChange(e) {
        const loadingToastUpdateCategory = toast.loading('Actualizando la categoría...', { duration: 1500 });
        const categoryId = this.props.match.params.id;
        const data = {
            isECOMVisible: e.target.checked
        }
        
        const prevValue = this.state.category.isECOMVisible;
        this.setState(prevState => {
            let category          = Object.assign({}, prevState.category);
            category[e.target.id] = e.target.checked;
            return {category};
        });

        NbioApi.categories.updateCategory(categoryId,data).then((res) => {
            toast.success('Categoría actualizada...', { id: loadingToastUpdateCategory })
        }).catch((ex) => {
            let errorMsg = 'Hubo un error al actualizar la categoría';
            this.setState(prevState => {
                let category          = Object.assign({}, prevState.category);
                category[e.target.id] = prevValue;
                return {category};
            });
            try{
                errorMsg = ex.response.data.error_es;
            }catch(ex){
                errorMsg = 'Servicio no disponible';
            }
            toast.error(errorMsg,{id:loadingToastUpdateCategory});
        });
    }
    
    loadCategory(categoryId) {
        this.setState({isLoading:true})
        NbioApi.categories.getCategory(categoryId).then(res => {
            this.setState({category: res.data.category, childrenCategories: res.data.childrenCategories});
        }).catch((ex) =>{

        }).finally(() =>{
            this.setState({isLoading:false})
        })
    }

    renderFilters(filterTags) {
        let text = "";

        if(filterTags){
            Object.entries(filterTags).forEach(([key,value]) => {
                text = `${text} ${value.locale_es}: `;
                const data = value.data;
                const arrayData = data.map((d) => d.label);
                text = `${text} ${arrayData.toString()} `;
                text = `${text} \n`
            });
        }
        return text;
    }

    render() {
        const category   = this.state.category ? this.state.category : {};
        const childrenCategories = this.state.childrenCategories ? this.state.childrenCategories : [];
        const columns = [
            {
                dataField: 'name',
                text: 'Nombre',
                formatter:(v,row) =>{
                    return(
                        <div>
                            <a href={`/categories/${row._id}`}>{v}</a>
                        </div>
                    )
                }
            },
            {
                dataField: 'isECOMVisible',
                text: 'Visible en la categoría padre',
                formatter:(v) =>{
                    const icon = v ? 'check' : 'times'
                    return <FontAwesomeIcon icon={icon}/>
                }
            },
            {
                dataField: 'images',
                text: 'Imagen',
                events: {
                    onClick: (e, column, columnIndex, row) => {
                        this.setState({selectedSubcategory:row,showImageOffcanvas:true})
                    },
                },
                formatter: (value, row) => {
                    let imageObj = value?.length > 0 ? value[0] : {};

                    if (imageObj?.url){
                        return <img className={'img-thumbnail ml-auto mr-auto text-center'}
                                    src={imageObj.url}
                                    alt={'Imagen de la categoría'}
                                    width={50}/>
                    }else{
                        return <small>Imagen no agregada</small>
                    }
                },
                headerStyle:(row,rowIndex) =>{
                    return {
                        width:'150px',
                    }
                }
            },
        ];

        return (
            <Container fluid style={{overflowY: "scroll"}} className={'h-100'}>
                <Row>
                    <Col className='py-3'>
                        <div className={'d-flex align-items-center justify-content-between'}>
                            <h5 className={'text-capitalize mr-auto'}>{`Categoría: ${category.name}`}</h5>
                            <Form.Group as={Row} className="" controlId="isECOMVisible">
                                <Col>
                                    <Form.Check
                                        type="switch"
                                        id="isECOMVisible"
                                        label="Visible en la categoría padre"
                                        checked={category.isECOMVisible}
                                        onChange={event => this.onChange(event)}/>
                                </Col>
                            </Form.Group>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col className='py-3' md={8}>
                        <Card>
                            <Card.Body>
                                <Card.Title className={'text-primary mb-3'}>Información general</Card.Title>

                                <Form.Group as={Row} className="mt-4 mb-3" controlId="name">
                                    <Form.Label column sm={2}>Nombre</Form.Label>
                                    <Col sm={10}>
                                        <Form.Control type="text" placeholder="Nombre" value={category.name} readOnly/>
                                    </Col>
                                </Form.Group>

                                <Form.Group as={Row} className="mt-4 mb-3" controlId="handleUrl">
                                    <Form.Label column sm={2}>URL</Form.Label>
                                    <Col sm={10}>
                                        <Form.Control type="text" placeholder="URL" value={category.handleUrl} readOnly/>
                                    </Col>
                                </Form.Group>

                                <Form.Group as={Row} className="mt-4 mb-3" controlId="products">
                                    <Form.Label column sm={2}>Número de productos</Form.Label>
                                    <Col sm={10}>
                                        <Form.Control type="text" placeholder="URL" value={category.products?.length} readOnly/>
                                    </Col>
                                </Form.Group>

                                <Form.Group as={Row} className="mt-4 mb-3" controlId="filterTags">
                                    <Form.Label column sm={2}>Filtros</Form.Label>
                                    <Col sm={10}>
                                        <Form.Control as="textarea" style={{height:'120px'}}
                                                      placeholder="Filtros"
                                                      value={this.renderFilters(category?.filterTags)} readOnly/>
                                    </Col>
                                </Form.Group>
                            </Card.Body>
                        </Card>

                    </Col>
                    <Col className='py-3' md={4}>
                        <Card.Title className={'text-primary'}>Imagen</Card.Title>
                        {/*<small className={"text-muted"}>La imagen debe ser cuadrada y de 512x512 pixeles. Al subir
                        otra medida, la imagen será deformada.</small>*/}
                        <CategoryImageUploader category={this.state.category}
                                               onImageUploaded={(categoryId) => this.loadCategory(categoryId)} />
                    </Col>
                </Row>
                <Row>
                    <Col className='pb-3' md={8}>
                        <Card>
                            <Card.Body>
                                <Card.Title className={'text-primary mb-3'}>Sub-categorías</Card.Title>
                                <BootstrapTable keyField='_id'
                                                data={childrenCategories}
                                                columns={columns}
                                                noDataIndication={`${category.name} no cuenta con sub-categorías`}
                                                bordered={false}
                                                condensed={true}
                                />
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        )

    }
}
export default withRouter(Category);

